export default __webpack_public_path__ + "static/media/logo.4b6fcb6d.png";